<div class="home-frame">
  <mat-toolbar class="toolbar gap-2">
    <button
      mat-icon-button
      class="mobile-only mobile-menu-toggle"
      (click)="toggleSidenav()"
      aria-label="Open navigation menu"
    >
      <mat-icon svgIcon="menu"></mat-icon>
    </button>

    <a class="toolbar-logo" routerLink="/" (click)="closeIfMobile()" aria-label="Go home">
      <nist-img
        filename="noodlistdark.png"
        alt="Noodlist"
        [width]="140"
        [height]="50"
        [priority]="true"
      />
    </a>
    <span class="spacer"></span>
    <div class="toolbar-actions">
      @if (session(); as s) {
        @if (profile(); as p) {
          @if (isAdmin()) {
            <a matButton="filled" routerLink="/admin" class="toolbar-admin-button">Admin Panel</a>
          }
          <button
            matRipple
            [routerLink]="['/profile', p.username]"
            routerLinkActive="active"
            class="w-10 h-10 flex items-center justify-center rounded-[2px] cursor-pointer overflow-hidden select-none"
            (click)="closeIfMobile()"
          >
            <app-avatar
              [avatarUrl]="p?.avatar_url"
              [username]="p?.username"
              [size]="'small'"
            ></app-avatar>
          </button>
        }
      } @else {
        <button matButton="filled" class="toolbar-auth-button" (click)="openLogin()">Login</button>
        <button matButton="filled" class="toolbar-auth-button" (click)="openRegister()">Sign Up</button>
      }
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="shell">
    <mat-sidenav
      #drawer
      class="sidenav"
      [mode]="isMobile ? 'over' : 'side'"
      [(opened)]="drawerOpen"
      (openedChange)="drawerOpen = $event">
      <div class="sidenav-inner">
        <nav class="nav-stack" aria-label="Primary navigation">
          <button
            class="nav-link"
            routerLink="/"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="closeIfMobile()">
            <span>Home</span>
          </button>
          <button class="nav-link" routerLink="/about" routerLinkActive="active-link" (click)="closeIfMobile()">
            <span>About</span>
          </button>
          <button class="nav-link" routerLink="/ramen" routerLinkActive="active-link" (click)="closeIfMobile()">
            <span>Browse</span>
          </button>
          <button class="nav-link" routerLink="/top-lists" routerLinkActive="active-link" (click)="closeIfMobile()">
            <span>Top 10 Lists</span>
          </button>
          <button class="nav-link" (click)="openSuggest(); closeIfMobile()">
            <span>Suggest</span>
          </button>
          @if (session()) {
            @if (profile(); as p) {
              <button
                class="nav-link"
                [routerLink]="['/profile', p.username]"
                routerLinkActive="active-link"
                (click)="closeIfMobile()">
                <span>Profile</span>
              </button>
              <button class="nav-link" (click)="signOut(); closeIfMobile()">
                <span>Log out</span>
              </button>
            }
          } @else {
            <button type="button" class="md:hidden nav-link" (click)="openLogin(); closeIfMobile()">
              <span>Login</span>
            </button>
            <button type="button" class="md:hidden nav-link" (click)="openRegister(); closeIfMobile()">
              <span>Sign Up</span>
            </button>
          }
        </nav>

        <div class="sidenav-footer">
          <div class="social-links" aria-label="Social links" role="group">
          <a
            matRipple
            class="social-link"
            [href]="twitterUrl || null"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="Twitter"
            (click)="handlePlaceholderClick($event, twitterUrl)"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" style="position: relative; left:-4px">
              <path
                d="M19.61 3.5h2.28l-5 5.36 5.89 8.64H17.2l-3.68-4.83-4.21 4.83H7.03l5.35-6.14-5.57-7.86h5.77l3.33 4.43 3.7-4.43Zm-2.4 13.44h1.26L8.88 4.99H7.52l9.69 11.95Z"
                fill="currentColor"
              />
            </svg>
          </a>
          <a
            matRipple
            class="social-link"
            [href]="youtubeUrl || null"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="YouTube"
            (click)="handlePlaceholderClick($event, youtubeUrl)"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path
                d="M21.58 7.2a2.5 2.5 0 0 0-1.76-1.77C18.25 5 12 5 12 5s-6.25 0-7.82.43A2.5 2.5 0 0 0 2.42 7.2 26.2 26.2 0 0 0 2 12a26.2 26.2 0 0 0 .42 4.8 2.5 2.5 0 0 0 1.76 1.77C5.75 19 12 19 12 19s6.25 0 7.82-.43a2.5 2.5 0 0 0 1.76-1.77A26.2 26.2 0 0 0 22 12a26.2 26.2 0 0 0-.42-4.8ZM10 15.5V8.5l6 3.5-6 3.5Z"
                fill="currentColor"
              />
            </svg>
          </a>
          <a
            matRipple
            class="social-link"
            [href]="instagramUrl || null"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="Instagram"
            (click)="handlePlaceholderClick($event, instagramUrl)"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path
                d="M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Zm0 2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7Zm11.25 1.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM12 8.25A3.75 3.75 0 1 1 8.25 12 3.75 3.75 0 0 1 12 8.25Zm0 2a1.75 1.75 0 1 0 1.75 1.75A1.75 1.75 0 0 0 12 10.25Z"
                fill="currentColor"
              />
            </svg>
          </a>
          </div>
        </div>
      </div>
    </mat-sidenav>


    <mat-sidenav-content class="content">
      <img class="page-yuki" src="/yuki_header2.png" alt="" aria-hidden="true" />
      <div class="content-main">
        <router-outlet></router-outlet>
      </div>
      <footer class="site-footer">
        <p>&copy; {{ currentYear }} Noodlist. All rights reserved.</p>
      </footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
